module.exports = __webpack_public_path__ + "img/emmelyn-pro.78e2f47e.jpg";